module.exports = __webpack_public_path__ + "res/ic_circle.274ab1fbd5c28cc7810eca63709a252c.png";